import { lazy } from "react";

const HomePage = lazy(() => import("./diet-model-page"));

const routes = [
  {
    path: "/diet-models",
    component: HomePage,
    exact: true,
    name: "Dietas Modelo"
  }
];

export default routes;
